module.exports = __webpack_public_path__ + "static/media/game-lobby-tiles.433f5314.png";